/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Stage } from './Stage';
import {
    StageFromJSON,
    StageFromJSONTyped,
    StageToJSON,
    StageToJSONTyped,
} from './Stage';
import type { VenueTypeEnum } from './VenueTypeEnum';
import {
    VenueTypeEnumFromJSON,
    VenueTypeEnumFromJSONTyped,
    VenueTypeEnumToJSON,
    VenueTypeEnumToJSONTyped,
} from './VenueTypeEnum';

/**
 * Serializer for Venue model with comprehensive validation.
 * @export
 * @interface Venue
 */
export interface Venue {
    /**
     * 
     * @type {string}
     * @memberof Venue
     */
    readonly id: string;
    /**
     * 
     * @type {number}
     * @memberof Venue
     */
    team: number;
    /**
     * 
     * @type {string}
     * @memberof Venue
     */
    readonly teamName: string;
    /**
     * 
     * @type {string}
     * @memberof Venue
     */
    name: string;
    /**
     * 
     * @type {VenueTypeEnum}
     * @memberof Venue
     */
    venueType?: VenueTypeEnum;
    /**
     * Address details: street, city, state, postal_code, country
     * @type {any}
     * @memberof Venue
     */
    address?: any | null;
    /**
     * Contact details: phone, email, website, social_media
     * @type {any}
     * @memberof Venue
     */
    contactInfo?: any | null;
    /**
     * Technical specifications: power, rigging, load_in, parking, etc.
     * @type {any}
     * @memberof Venue
     */
    technicalSpecs?: any | null;
    /**
     * 
     * @type {string}
     * @memberof Venue
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Venue
     */
    isActive?: boolean;
    /**
     * 
     * @type {Array<Stage>}
     * @memberof Venue
     */
    readonly stages: Array<Stage>;
    /**
     * 
     * @type {string}
     * @memberof Venue
     */
    readonly stagesCount: string;
    /**
     * 
     * @type {string}
     * @memberof Venue
     */
    readonly totalCapacity: string;
    /**
     * 
     * @type {Date}
     * @memberof Venue
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Venue
     */
    readonly updatedAt: Date;
}



/**
 * Check if a given object implements the Venue interface.
 */
export function instanceOfVenue(value: object): value is Venue {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('team' in value) || value['team'] === undefined) return false;
    if (!('teamName' in value) || value['teamName'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('stages' in value) || value['stages'] === undefined) return false;
    if (!('stagesCount' in value) || value['stagesCount'] === undefined) return false;
    if (!('totalCapacity' in value) || value['totalCapacity'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function VenueFromJSON(json: any): Venue {
    return VenueFromJSONTyped(json, false);
}

export function VenueFromJSONTyped(json: any, ignoreDiscriminator: boolean): Venue {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'team': json['team'],
        'teamName': json['team_name'],
        'name': json['name'],
        'venueType': json['venue_type'] == null ? undefined : VenueTypeEnumFromJSON(json['venue_type']),
        'address': json['address'] == null ? undefined : json['address'],
        'contactInfo': json['contact_info'] == null ? undefined : json['contact_info'],
        'technicalSpecs': json['technical_specs'] == null ? undefined : json['technical_specs'],
        'description': json['description'] == null ? undefined : json['description'],
        'isActive': json['is_active'] == null ? undefined : json['is_active'],
        'stages': ((json['stages'] as Array<any>).map(StageFromJSON)),
        'stagesCount': json['stages_count'],
        'totalCapacity': json['total_capacity'],
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
    };
}

  export function VenueToJSON(json: any): Venue {
      return VenueToJSONTyped(json, false);
  }

  export function VenueToJSONTyped(value?: Omit<Venue, 'id'|'team_name'|'stages'|'stages_count'|'total_capacity'|'created_at'|'updated_at'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'team': value['team'],
        'name': value['name'],
        'venue_type': VenueTypeEnumToJSON(value['venueType']),
        'address': value['address'],
        'contact_info': value['contactInfo'],
        'technical_specs': value['technicalSpecs'],
        'description': value['description'],
        'is_active': value['isActive'],
    };
}

